import { Phone, MessageCircle } from "lucide-react";
import { useSettings } from "@/context/AppContext";
import { buildWhatsAppUrl } from "@/lib/phone";

export default function FloatingCTA() {
  const { settings } = useSettings();
  if (!settings) return null;
  const waUrl = buildWhatsAppUrl(settings.contact_whatsapp);
  const phone = (settings.contact_phone || "").replace(/\s/g, "");

  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3 lg:bottom-8 lg:right-8" data-testid="floating-cta">
      {waUrl && (
        <a
          href={waUrl}
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp"
          data-testid="floating-whatsapp"
          className="w-13 h-13 w-[56px] h-[56px] rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg shadow-forest/20 hover:scale-110 transition"
        >
          <MessageCircle className="w-6 h-6" />
        </a>
      )}
      {phone && (
        <a
          href={`tel:${phone}`}
          aria-label="Téléphone"
          data-testid="floating-phone"
          className="lg:hidden w-[56px] h-[56px] rounded-full bg-forest text-cream flex items-center justify-center shadow-lg shadow-forest/30 hover:scale-110 transition"
        >
          <Phone className="w-5 h-5" />
        </a>
      )}
    </div>
  );
}
